import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useElementSize } from 'usehooks-ts'
import { geoMercator, geoPath } from 'd3-geo'
import Region from 'components/Region'

import RegionsMapGE from './communes_sans_lac.json'
import RegionsMapVD from './communes_vaud.json'

interface Props {
  canton: 'GE' | 'VD'
  activeRegion?: string | null
  height: number
  colorMode: 'light' | 'dark'
  handleMapEvent: (event: any) => void
}
const Map: FC<Props> = ({
  canton,
  activeRegion = null,
  height,
  colorMode,
  handleMapEvent,
}): ReactElement => {
  const projection = useRef<any>(null)
  const RegionsMap = canton === 'GE' ? RegionsMapGE : RegionsMapVD
  const [container, size] = useElementSize()
  const [{ width }, setSize] = useState({
    width: 100,
  })
  projection.current = geoMercator().fitSize([width, height], RegionsMap as any)
  useEffect(() => {
    if (size.width && size.height) {
      setSize({ width: size.width })
      projection.current = geoMercator().fitSize(
        [size.width, size.height],
        RegionsMap as any
      )
    }
  }, [size, RegionsMap])

  const path = geoPath().projection(projection.current)

  return (
    <MapContainer ref={container}>
      <StyledSVG width={width} height={height}>
        {RegionsMap.features.map((item: any) => {
          return (
            <Region
              key={item.properties.id}
              canton={canton}
              name={item.properties.name}
              category={item.properties.category}
              active={item.properties.name === activeRegion}
              path={path(item)}
              colorMode={colorMode}
              handleMapEvent={handleMapEvent}
            />
          )
        })}
      </StyledSVG>
    </MapContainer>
  )
}
const MapContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: inline-block;
  flex: 0 0 53%;
  margin-bottom: 30px;
  overflow: hidden;
  @media only screen and (max-width: 711px) {
    flex: 0 0 45%;
  }
`
const StyledSVG = styled.svg`
  overflow: visible;
`

export default Map
